export default __webpack_public_path__ + "static/media/Woman_picture.cf1e0944.PNG";